import * as Config from '../../../../../../config';
import React, {useState, useCallback, useEffect} from 'react';
import PropTypes from 'prop-types';

import CoverFlowWrapper from '../../../../coverflow/CoverFlowWrapper';
import MainManager from '../../../../content/MainManager';
import Play from '../../svg/Play';
import Pause from '../../svg/Pause';
import Expand from '../../svg/Expand';
import Next from '../../svg/Next';
import Previous from '../../svg/Previous';
import Minimize from '../../svg/Minimize';
import PoweredBy from '../../svg/PoweredBy';
import Player from '@vimeo/player';
import Settings from '../../svg/Settings';

import {
  setFullWidthIframe,
  setMinimizePlaylistIframe,
  setVideoIframe,
  setStateVideoIframe
} from "../../mods/iframe/redux/actions/index";

import { connect, useDispatch } from "react-redux";

let player = null;
let intervalTracker = null;
let stateFullVideo = false;

function ConnectedLearnEnv({
  maxWidth, maxHeight, fullHeight, playerCoordinates,
  api, isFullScreen, isFullWidthIframe,
  setFullWidthIframe, treeVideos, video, stateVideo,
  setMinimizePlaylistIframe, isMinimizePlaylist, setStateVideoIframe
}) {
  document.getElementById(`DJAPPMM_container`).style[`max-width`] = `1410px`;
  document.getElementById(`alpha3`).style[`background`] = `#19191B`;

  const dispatch = useDispatch();
  const [isFull, setFull] = useState(false);

  const height = maxHeight - playerCoordinates.height;
  const padIframe = 16;
  const pad = 42;
  const sizeCover = Config.PLAYLIST_COVER_SIZE + pad;
  const mainWidth = maxWidth + Config.SUB_SIDEBAR + (Config.CONTENT_PAD * 2);
  const videoWidth = 256;
  const bottomBarHeight = 56;

  const playpause = () => {
    if (player) {
      if (stateVideo === 1) {
        player.pause();
      } else {
        player.play();
      }
    }
  }
  const toggleExpand = () => {
    if (!isMinimizePlaylist) {
      stateFullVideo = !isFull;
      //YT
      setFullWidthIframe(stateFullVideo);
      setFull(stateFullVideo);

      //vimeo
      if (player) {
        player.element.width = stateFullVideo ? (((height-bottomBarHeight)*16)/9) : videoWidth;
        player.element.height = stateFullVideo ? height - bottomBarHeight : sizeCover;
      }
    }
  }
  const toggleMinimize = () => {
    if (!isFull) {
      setMinimizePlaylistIframe(!isMinimizePlaylist);
    }
  }

  /** Sync with parent **/

  const next = useCallback(() => {
    const indexActive = treeVideos.findIndex( x => x.contentId === video.contentId );
    if (treeVideos[indexActive + 1]) {
      dispatch(setVideoIframe(treeVideos[indexActive + 1]))
      window.parent.postMessage([{
        "action": "navigate",
        "lessonId": treeVideos[indexActive + 1].contentId
      }], "*");
    }
  }, [treeVideos, video, dispatch])
  const previous = useCallback(() => {
    const indexActive = treeVideos.findIndex( x => x.contentId === video.contentId );
    if (treeVideos[indexActive - 1]) {
      dispatch(setVideoIframe(treeVideos[indexActive - 1]))
      window.parent.postMessage([{
        "action": "navigate",
        "lessonId": treeVideos[indexActive - 1].contentId
      }], "*");
    }
  }, [treeVideos, video, dispatch])
  const updateTracker = useCallback((data) => {
    window.parent.postMessage([{
      "action": "update",
      "courseId": video.courseId,
      "lessonId": video.contentId,
      "actualTimeTracker": data.seconds,
      "lessonEnd": (data.percent === 1)
    }], "*");
  }, [video]);

  //Vimeo
  useEffect(() => {
    if (api && video) {
      // console.log(`ACTIVE LESSON`, video);

      const initPlayer = () => {
        player = new Player('vTuto', {
          id: video.vimeoId,
          width: stateFullVideo ? (((height-bottomBarHeight)*16)/9) : videoWidth,
          height: stateFullVideo ? height - bottomBarHeight : sizeCover
        });
        player.setCurrentTime(video.actualTimeTracker);

        player.on('play', function(data) {
          setStateVideoIframe(1);
          if (!intervalTracker) {
            intervalTracker = setInterval(() => {
              player.getCurrentTime().then((seconds) => { updateTracker({ seconds, percent: null })  })
            }, 10000);
          }
        });
        player.on('pause', function(data) {
          setStateVideoIframe(-1);
          clearInterval(intervalTracker);
          intervalTracker = null;
        });
        player.on('seeking', updateTracker);
        player.on('ended', updateTracker);
        clearInterval(intervalTracker);
        intervalTracker = null;
      }

      if (!player) {
        initPlayer();
      } else {
        clearInterval(intervalTracker);
        intervalTracker = null;
        player.destroy().then(() => {
          initPlayer();
        })
      }

    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [api, video, videoWidth, sizeCover, setStateVideoIframe])

  const openSettings = () => {
    if (window.settings_panel_show) {
      window.settings_panel_show();
      document.getElementById('settings').style['left'] = '18%';
    }
  }

  return (
    <div className={`flexColumn`}>
      <CoverFlowWrapper maxWidth={maxWidth} isFullHeight={fullHeight}
        height={ isFullScreen ? maxHeight : playerCoordinates.height }
        isFullScreen={isFullScreen} />
      <div className={`nextbeat flexRow center`}>
        <MainManager className={isFullWidthIframe ? `opacity-none` : `opacity-full`} maxWidth={mainWidth - 240} height={height - bottomBarHeight} playerCoordinates={playerCoordinates} fullHeight={fullHeight} />
        <div id="vTuto" style={{ border: `none`, backgroundColor: Config.SYSTEM_BLACK_2, position: `absolute`, left: isFullWidthIframe ? `unset` : /*maxWidth - videoWidth - padIframe*/ `calc(50% - 128px)` , bottom: isFullWidthIframe ? bottomBarHeight : `unset`, top: isFullWidthIframe ? `unset` : playerCoordinates.height + padIframe, zIndex: 100, opacity: isMinimizePlaylist ? 0 : 1 }}></div>
      </div>
      <div className={`flexRow center align`} style={{position: `fixed`, width: `100%`, height: bottomBarHeight, background: `#020202`, left: 0, bottom: 0}}>
        <Previous className={`gutter-actions-video`} onClick={previous} />
        <Minimize className={`gutter-actions-video`} state={isMinimizePlaylist} onClick={toggleMinimize} />
        { stateVideo === 1 ? <Pause className={`gutter-actions-video`} onClick={playpause} /> : <Play className={`gutter-actions-video`} onClick={playpause} /> }
        <Expand className={`gutter-actions-video`} state={isFullWidthIframe} onClick={toggleExpand} />
        <Next className={`gutter-actions-video`} onClick={next} />
        <Settings className={'learn-icon-settings'} style={{ cursor: `pointer`, position: `absolute`, right: document.getElementById(`player1b`).getBoundingClientRect().left + 170}} onClick={openSettings} />
        <PoweredBy style={{ position: `absolute`, right: document.getElementById(`player1b`).getBoundingClientRect().left + 10}} />
      </div>
    </div>
  )

}

ConnectedLearnEnv.propTypes = {
  maxWidth: PropTypes.number.isRequired,
  maxHeight: PropTypes.number.isRequired,
  fullHeight: PropTypes.bool.isRequired,
  playerCoordinates: PropTypes.object.isRequired
}

const LearnEnv = connect(
  state => ({
    api: state.api,
    isFullScreen: state.isFullScreen,
    isFullWidthIframe: state.IFullWidth,
    isMinimizePlaylist: state.IMinimizePlaylist,
    treeVideos: state.ITreeVideos,
    video: state.IVideo,
    stateVideo: state.IStateVideo
  }),
  dispatch => ({
    setFullWidthIframe: (state) => dispatch(setFullWidthIframe(state)),
    setMinimizePlaylistIframe: (state) => dispatch(setMinimizePlaylistIframe(state)),
    setStateVideoIframe: state => dispatch(setStateVideoIframe(state))
  })
)(ConnectedLearnEnv);

export default LearnEnv;
